import { H5 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { shortFormatDate } from '@liveauctioneers/caterwaul-components/lib/utils/dates';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';
import styled from 'styled-components';

import { Payment } from '@/types/Invoice';

import InvoiceSummaryList from './components/InvoiceSummaryList';
import InvoiceSummaryListRow from './components/InvoiceSummaryListRow';

type Props = {
    currency: string;
    payments: Payment[];
    paymentsTotal: number;
};

const InvoiceSummaryPayments = ({ currency, payments, paymentsTotal }: Props) => {
    return (
        <InvoiceSummaryList>
            <StyledListTitle>
                <FormattedMessage id="checkout.invoice_summary.payments_title" />
            </StyledListTitle>
            {payments.map((payment) => {
                return (
                    <div key={payment.ts_now_ts}>
                        <InvoiceSummaryListRow
                            amount={{ amount: payment.amount, currency }}
                            label={shortFormatDate(payment.ts_now_ts)}
                        />
                    </div>
                );
            })}
            {payments.length > 1 && (
                <>
                    <InvoiceSummaryListRow
                        amount={{ amount: paymentsTotal, currency }}
                        bold
                        label={<FormattedMessage id="checkout.totalPaid" />}
                    />
                </>
            )}
        </InvoiceSummaryList>
    );
};

export default InvoiceSummaryPayments;

const StyledListTitle = styled(H5)`
    margin-bottom: 16px;
`;
